import {format, parseISO} from "date-fns";

const domain = window.location.hostname;
const port = window.location.port;
const protocol = window.location.protocol;

export const getRequesterName = (id, type, requestorTypes) => {
    if (
        !id ||
        !type ||
        !(type in requestorTypes) ||
        !Array.isArray(requestorTypes[type])
    ) {
        console.log(`${id}:${type} requestorType not found`);
        return null;
    }

    const requester = requestorTypes[type].find((s) => s && s.id == id);

    if (!requester) {
        return null;
    }

    if (typeof requester === "object") {
        if (requester.lastName && requester.firstName) {
            return `${requester.lastName}, ${requester.firstName}`;
        } else if (requester.name) {
            return requester.name;
        } else if (requester.committeeDetails?.committeeCode?.name) {
            return requester.committeeDetails.committeeCode.name;
        }
    }

    return null;
};

export const processBill = (bill, requestorTypes) => {
    if (!bill || !bill.draft) {
        console.error("Invalid bill object");
        return null;
    }

    const {requesterId, requesterType, byRequestOfs} = bill.draft;

    // Try to get requester name, but don't fail if not found
    if (requesterId && requesterType) {
        bill.requester = getRequesterName(
            requesterId,
            requesterType,
            requestorTypes
        );
    }

    // Process byRequestOf if available
    if (Array.isArray(byRequestOfs) && byRequestOfs.length > 0) {
        const {byRequestOfId, billRequestType} = byRequestOfs[0];
        if (byRequestOfId && billRequestType) {
            bill.byRequestOf = getRequesterName(
                byRequestOfId,
                billRequestType,
                requestorTypes
            );
        }
    }

    return bill;
};

export const getFullDomain = () => {
    if (port) return `${domain}:${port}`;
    return domain;
};

export const createFullUrl = (path) => {
    return `${protocol}//${getFullDomain()}${path}`;
};

export const convertISOToReadableTimeFormat = (date) => {
    return format(parseISO(date), "MM/dd/yy");
};

export const convertToISOString = (dateString) => {
    const [month, day, year] = dateString.split("/");
    const date = new Date(year, month - 1, day);
    return date.toISOString();
};

export const getSponsorPayload = (text, selectedLegislator) => {
    let sponsorIds = new Set();

    if (selectedLegislator) {
        sponsorIds.add(selectedLegislator);
    }
    return { sponsorIds: Array.from(sponsorIds) };
};

export const getPrimarySponsor = (primarySponsorBillRole, billType) => {
    if (primarySponsorBillRole.length === 0) {
        return null;
    }
    const primarySponsor = primarySponsorBillRole[0];
    if (
        primarySponsor &&
        primarySponsor.lawEntity &&
        primarySponsor.legislator &&
        primarySponsor.legislator.politicalParty
    ) {
        return `${primarySponsor.lawEntity.lastName}, ${
            primarySponsor.lawEntity.firstName
        } (${primarySponsor.legislator.politicalParty.partyCode}) ${
            billType ? (billType.startsWith("H") ? "HD" : "SD") : ""
        } ${primarySponsor.legislator.districtNumber}`;
    }
    return null;
};


export const getFirstNonFiscalResult = (dataArray) => {
    if (!Array.isArray(dataArray) || dataArray.length === 0) {
        return null; // Handle empty or invalid input
    }

    for (const item of dataArray) {
        if (
            item.billStatusCode &&
            item.billStatusCode.name &&
            !item.billStatusCode.name.toLowerCase().includes("fiscal note") &&
            !item.billStatusCode.name.toLowerCase().includes("(h) fiscal") &&
            !item.billStatusCode.name.toLowerCase().includes("(s) fiscal")
        ) {
            return item;
        }
    }

    return dataArray[0];
};

export const filterValidValues = (obj) => {
    const validObj = {};
    Object.entries(obj).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== false) {
            if (Array.isArray(value) && value.length > 0) {
                validObj[key] = value;
            } else if (typeof value === "string" && value.trim() !== "") {
                validObj[key] = value;
            } else if (!Array.isArray(value) && typeof value !== "string") {
                validObj[key] = value;
            }
        }
    });
    return validObj;
};

export const processContentWhenReady = (
    content,
    allRequestorData,
    billsWithLcTextAvailable
) => {
    if (!allRequestorData || allRequestorData.length === 0) {
        return content;  // Return unprocessed content if no requestor data
    }

    const requestorTypes = {
        LEGISLATOR: allRequestorData[0]?.content,
        STANDING_COMMITTEE: allRequestorData[1],
        NON_STANDING_COMMITTEE: allRequestorData[2],
        ELECTED_OFFICIAL_POSITION: allRequestorData[3]?.content,
        ORGANIZATION: allRequestorData[4],
        AGENCY: allRequestorData[4],
        AGENCY_ON_BEHALF_OF_NON_STANDING_COMMITTEE: allRequestorData[4],
        AGENCY_ON_BEHALF_OF_STANDING_COMMITTEE: allRequestorData[4],
    };

    const processedContent = content
        .map((bill) => processBill(bill, requestorTypes))
        .filter(Boolean);

    return processedContent.map((bill) => ({
        ...bill,
        lcTextAvailable: bill?.draft?.draftNumber
            ? billsWithLcTextAvailable?.find(
                (b) => b.fileName === `${bill.draft.draftNumber}.pdf`
            ) || false
            : false,
    }));
};
